import { SingleToolFooter, SingleToolHeader, SingleToolSimilar } from '../../common';
import { WithBreadcrumb } from '../../core';

import useStyles from './styles';
import { IWithLanding } from './types';

function WithLanding({
  children,
  analytics,
  currentTool,
  breadcrumbItems,
  similarTools,
  similarToolsParagraph,
  notification,
  toolCategory,
  otherTools,
}: IWithLanding) {
  const classes = useStyles();
  return (
    <div>
      <SingleToolHeader
        analytics={analytics}
        className={classes.header}
        toolName={currentTool.id}
        widgetUrl={currentTool.widgetUrl}
      />
      {notification}
      <WithBreadcrumb items={breadcrumbItems} />

      {children}

      {similarTools && (
        <SingleToolSimilar
          otherTools={otherTools}
          category={toolCategory}
          current={currentTool}
          paragraph={similarToolsParagraph}
          similar={similarTools}
          analytics={analytics}
        />
      )}
      <SingleToolFooter analytics={analytics} />
    </div>
  );
}

export default WithLanding;
